<template>
  <div class="not-found">
    <h1>{{ message }}</h1>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VNotFound',
  props: {
    message: {
      type: String,
      default: `404 - Cette page n'existe pas`,
    },
  },
})
</script>

<style lang="scss">
.not-found {
  text-align: center;
  padding: 150px 15px;
  background-position: center;
  background-size: cover;
}
</style>
